import { AppLoader, FullContainer, GenericErrorScreen } from '../../../shared';
import { CreateCaseScreen } from '../../forms/page/components';
import {
  UbbleCheckoutSdkProvider,
  usePollCaseChecksAutomation,
} from '../shared';
import { ChecksHeader, ChecksTabList } from './components';
import { ChecksModal } from './components/checks-modal';
import { usePollCaseChecks } from './hooks';

export const ChecksPage = () => {
  const { loading, error, hasOngoingPipelineWithClientPortalStages } =
    usePollCaseChecksAutomation();

  // Mount this hook at the route-area level to keep the hook internal state
  usePollCaseChecks({
    skip: loading || (hasOngoingPipelineWithClientPortalStages ?? true),
  });

  if (hasOngoingPipelineWithClientPortalStages) {
    // Keep the same loading screen as when the forms are being submitted
    // while automation are running
    return <CreateCaseScreen />;
  }

  if (loading) {
    return <AppLoader />;
  }

  if (error) {
    return <GenericErrorScreen error={error} />;
  }

  return (
    <UbbleCheckoutSdkProvider>
      <FullContainer>
        <ChecksHeader />
        <ChecksTabList />
        <ChecksModal />
      </FullContainer>
    </UbbleCheckoutSdkProvider>
  );
};
